export const SETUP_STICKY_OFFSET = 72;

const sectionTop = (id) => {
  const node = document.getElementById(id);
  if (!node) return null;
  return Math.max(
    0,
    node.getBoundingClientRect().top + window.scrollY - SETUP_STICKY_OFFSET
  );
};

export const jumpToSetupSection = (id, behavior = "smooth") => {
  const top = sectionTop(id);
  if (top == null) return false;
  window.scrollTo({ top, behavior });
  return true;
};

export const followSetupHash = (id) => {
  if (!id) return () => {};

  let lastTop = null;
  let stableFrames = 0;
  let stopped = false;

  const jump = () => {
    if (stopped) return true;
    const top = sectionTop(id);
    if (top == null) return false;
    if (lastTop != null && Math.abs(lastTop - top) < 2) {
      stableFrames += 1;
    } else {
      stableFrames = 0;
      window.scrollTo({ top, behavior: "auto" });
    }
    lastTop = top;
    return stableFrames >= 3;
  };

  jump();
  const interval = window.setInterval(() => {
    if (jump()) window.clearInterval(interval);
  }, 100);
  const timeout = window.setTimeout(() => {
    window.clearInterval(interval);
  }, 2000);

  return () => {
    stopped = true;
    window.clearInterval(interval);
    window.clearTimeout(timeout);
  };
};
